// extracted by mini-css-extract-plugin
export default {"wrapper":"PvDispersionRate_wrapper__S+8YK"};